//点聚合专题图配置
import { getDispatcher } from '@/utils/analysisTools/';
import WFSBean from '@/utils/analysisTools/beans/WFSBean';

import ClusterMapLayer from '../components/ClusterMapLayer.js';
import { request } from '@/utils/http.js';

export default {
    //检查参数是否完整
    checkParameter(json) {
        try {
            const parameter = {};
            parameter.zoomRange = json.configcont.basic.zoomRange;
            const thematic = json.configcont.thematic;
            parameter.url = thematic.serviceUrl;
            parameter.layerName = thematic.serviceLayer;
            for (const values of Object.values(parameter)) {
                if (values === undefined) {
                    return false;
                }
            }
            return parameter;
        } catch {
            return false;
        }
    },
    async initLayer(vm, id, url, layerName, zoomRange, imgUrl) {
        const MapView = vm.MapView;

        const queryParams = {
            url: url,
            layerName: layerName,
        };
        const bean = new WFSBean(queryParams);
        return new Promise((resolve, reject) => {
            getDispatcher(vm)
                .read(bean)
                .then(result => {
                    const features = result.geojson;
                    const _features = features.map(feature => {
                        feature.properties['_planId'] = id;
                        return feature;
                    });
                    const wfsLayer = new ClusterMapLayer('custom', zoomRange);
                    if (imgUrl != '') {
                        getBFileDetial(imgUrl).then(imageData => {
                            MapView.map.loadImage(imageData, function (
                                error,
                                image
                            ) {
                                const imgId = 'gradient' + Math.random();
                                MapView.map.addImage(imgId, image);
                                wfsLayer.setMap(MapView.map, imgId);
                                wfsLayer.setData(_features);
                                resolve(wfsLayer);
                            });
                        });
                    } else {
                        wfsLayer.setMap(MapView.map, '');
                        wfsLayer.setData(_features);
                        resolve(wfsLayer);
                    }
                    // wfsLayer.setMap(MapView.map, '');
                    // wfsLayer.setData(_features);
                    // resolve(wfsLayer);
                })
                .catch(() => {
                    vm.$Message.error('方案数据解析失败，请检查数据配置！');
                    reject();
                });
        });
    },
};
function getBFileDetial(imgUrl) {
    imgUrl = "admin/" + imgUrl
    return request(imgUrl).then(res => {
        return res.imageData;
    });
}
